<template>
  <div
    class="forma-podnikania-group"
    v-if="l_visible"
    :class="{ readonly: readonly || getDisabled || isLoading }"
  >
    <v-btn-toggle
      :value="l_value"
      v-bind:class="{}"
      class="forma-podnikania-group-row row ma-0"
      :mandatory="mandatory"
      group
      @change="onChange"
    >
      <template v-for="(item, index) in l_data">
        <v-btn
          :key="index"
          :value="item.valueMember"
          :small="small"
          :disabled="getDisabled || isItemDisabled(item)"
        >
          <div class="forma-podnikania-icon">
            <v-icon>{{ getIcon(item.valueMember) }}</v-icon>
          </div>
          <div class="forma-podnikania-text">
            <span>{{ item.displayMember }}</span>
          </div>
        </v-btn>
      </template>
    </v-btn-toggle>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  watch: {
    value(val) {
      if (val !== this.l_value) {
        this.setDirty(true);
        this.update(val);
      }
    },
  },
  mixins: [dynamicControlMixin],
  props: {
    items: Array,
    value: [String, Number, Array],
    small: Boolean,
    label: String,
    info: String,
    mandatory: {
      type: Boolean,
      default: true,
    },
    max: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      l_value: null,
      viewObjectText: null,
      viewObjectInfoText: null,
      l_data: [],
      labelVisible: true,
    };
  },
  computed: {
    getDisabled() {
      return this.disabled || this.isDisabled;
    },
  },
  methods: {
    onChange(val) {
      this.setDirty(true);
      this.update(val);
    },
    update(val) {
      this.l_value = val;
      this.$emit('input', val);
      if (this.dirty) {
        this.saveValue(val);
      }
    },
    readData(config, data) {
      this.viewObjectText = config.viewObjectText;
      this.viewObjectInfoText = config.viewObjectInfoText;
      if (this.l_data.length === 0) {
        this.l_data = data;

        if (!data) {
          let i = 0;
          this.l_data = this.viewObjectText.split('#').map(o => {
            //toto vymyslel Skyfko ze pri jednoduchych prepinacoch dat tie moznosti do nazvu oddelene #
            let curr = {
              valueMember: i,
              displayMember: o,
            };
            i++;
            if (!this.staticLabel) this.labelVisible = false;
            return curr;
          });
        }
      }

      if (config.controlValue !== null && config.controlValue !== undefined) {
        this.l_value = config.controlValue;
        this.$emit('input', this.l_value);
      }
    },
    getValue() {
      return this.l_value;
    },
    isItemDisabled(item) {
      if (item?.is_enabled != null) {
        return !item?.is_enabled ? true : false;
      } else {
        return false;
      }
    },
    getIcon(value) {
      switch (value) {
        case 1:
          return '$forma_pravnicka';
        case 2:
          return '$forma_podnikatel';
        case 3:
          return '$forma_spotrebitel';
      }
    },
  },
  created() {
    this.l_dataId = 'liw_filip__wiz_najomca__cb_forma_podn';
    if (!this.dynamic) {
      if (this.items) this.l_data = this.items;
    }

    if (this.value) this.l_value = this.value;
  },
  mounted() {
    if (!this.data_id && this.data.length > 0) {
      this.l_data = this.data;
    }
  },
};
</script>
